import * as React from 'react';
import {
    CourseObject, useCreateStageMutation,
    useLanguageCoursesQuery
} from "../../../../types.d";
import {Link} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import {useState} from "react";

export const CourseBlock = (props: { baseUrl: string, course: CourseObject }) => {
    const { course } = props;
    const [createdStages, setCreatedStages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [ createStage, { data: createdStage } ] = useCreateStageMutation();

    return <div className={'card mb-3'}>
        <div className={'card-header'}>
            <h3 className={'m-2'}>{ course.sourceLanguage.name } -> { course.translationLanguage.name }</h3>
        </div>

        <div className={'card-body p-3'}>
            { [...course.stages, ...createdStages].map(item => (
                <div className={'card mb-3'} key={item.id}>
                    <div className="card-header">
                        <div className={'row'}>
                            <div className="col">
                                <h4 className="m-0">Stage { item.level } <small>({ item.countExplanationCards } Explanation Cards)</small></h4>
                            </div>
                            <div className="ml-2 col-4 text-right">
                                <Link to={`${props.baseUrl}/stage/${item.id}/topic`} className="btn btn-outline-primary btn-sm mr-1">Add Topic</Link>
                                <Link to={`${props.baseUrl}/stage/${item.id}/legs`} className="btn btn-outline-primary btn-sm">Legs</Link>
                            </div>
                        </div>
                    </div>

                    { item.topics.map(topic => (
                        <div className={'row m-1'} key={topic.id}>
                            <div className={'col'}>
                                <h6 className={'m-2'}>{ topic.title }</h6>
                            </div>
                            <div className={'col-4 text-right'}>
                                <Link to={`${props.baseUrl}/topic/${topic.id}`} className={'btn btn-outline-primary btn-sm'}>See content and Edit</Link>
                            </div>
                        </div>
                    )) }
                </div>
            )) }

            <a href={``}
               onClick={async e => {
                   e.preventDefault();

                   if (loading) {
                       return;
                   }

                   setLoading(true);
                   const result = await createStage({
                       variables: {
                           input: {
                               postTitle: `Stage ${course.stages.length + 1}`,
                               level: course.stages.length + 1,
                               course: course.id
                           }
                       }
                   });

                   setCreatedStages([
                       ...createdStages,
                       result.data.createStage
                   ]);

                   setLoading(false);
               }}
               className={'btn btn-outline-primary'}>Add stage{ loading ? ' (In progress...)' : '' }</a>
        </div>
    </div>
};

export const LanguageCoursesPage = (props: RouteComponentProps<{ language: string }>) => {
    const courses = useLanguageCoursesQuery({
        variables: {
            languageId: Number(props.match.params.language)
        }
    });

    if (!courses.data) {
        return <h2>Loading...</h2>
    }

    const coursesList = courses.data.coursesByLanguage;

    return <div>
        <div className={'mb-3'}>
            <Link to={`/courses/create`} className={'btn btn-outline-primary'}>Create new course</Link>
        </div>

        { coursesList.map(item => <CourseBlock
            key={item.id}
            baseUrl={`${props.match.url}`}
            course={item as CourseObject} />) }
    </div>
};
